import { render, staticRenderFns } from "./del_popup1.vue?vue&type=template&id=24c5dc26"
import script from "./del_popup1.vue?vue&type=script&lang=js"
export * from "./del_popup1.vue?vue&type=script&lang=js"
import style0 from "./del_popup1.vue?vue&type=style&index=0&id=24c5dc26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports